export default "__VITE_ASSET__365e533b__"